export const FILTERS_TYPE = {
  SELECT: 'filterListDynamic',
  AUTO_COMPLETE: 'filterTextAutoComplete'
};
